// 商城订单相关函数
import { payOrder, cancelOrder, applyRefund, cancelRefund, sureFinished, dealServiceOrder, dealServiceOrderRefund } from '@/api/order'
import staticConfig, {
  cancelOrderBtn,
  cancelServiceRefundBtn,
  applyRefundBtn,
  applyServiceRefundBtn,
  sureFinishedBtn,
  creatOabBtn,
  viewOabBtn,
  EWOrderTypeFlag
} from '@/util/order/staticConfig'
import copyImg from '@/assets/images/copy.png'
import verifyImg from '@/assets/images/verify.png'
import typeImg from '@/assets/images/tyre.png'
import discountImg from '@/assets/images/discount.png'
import { addEightHour, isNum } from '@/util/index'
import { couponList } from '@/util/plan'
import { showToast } from '@/util/couponCollection'
import moment from 'moment'
import _ from 'lodash'

//服务合约 orderTypeFlagArr
export const CONTRACT_SERVICES_ORDER_TYPE_FLAGS = [6, 9, 10, EWOrderTypeFlag]

// 判断是否为OTR线下订单或新车销售订单
export const isOtrOrNewCarOrder = (order) => {
  return order.salesChannel === 'OTROFFLINE' || order.salesChannel === 'NEWCAROTRQR';
}

const afterSales = data => {
  // 经销商电话
  let phoneNum = data?._data?.dealer?.tel || ''
  if (phoneNum) {
    clickIcon({ icon: 'phone', value: phoneNum })
  } else {
    showToast(`电话号码有误,请联系经销商门店`)
  }
  return true
}

// 点击订单各按钮的回调函数
const cbFnObj = {
  payOrder,
  cancelOrder,
  applyRefund,
  cancelRefund,
  sureFinished,
  afterSales,
  dealServiceOrder,
  dealServiceOrderRefund
}

const getTypePrice = data => {
  if (isNum(data.afterDiscountPrice)) {
    return data.afterDiscountPrice
  }
  if (isNum(data.productDiyPrice)) {
    return data.productDiyPrice
  }
  if (isNum(data.productPrice)) {
    return data.productPrice
  }
  return ''
}

// 配置状态id
const getStatusId = data => {
  let statusId = ''
  if (data.orderTypeFlag === 1) {
    statusId =
      data.refundStatusFlag && (data.orderStatusFlag == 4 || data.orderStatusFlag == 5)
        ? `${data.orderStatusFlag}${data.refundStatusFlag}`
        : data.orderStatusFlag
  }

  if (data.orderTypeFlag === 2 || data.orderTypeFlag === 4) {
    if ([1, 2, 7].includes(data.orderStatusFlag)) {
      statusId = data.orderStatusFlag
    }
    if (data.orderStatusFlag === 9) {
      statusId = 6
    }
    if (data.orderStatusFlag === 6) {
      statusId = data.payMethodFlag === 3 ? 3 : 5
    }
    if (data.orderStatusFlag === 4) {
      if (data.payMethodFlag === 7) {
        statusId = 4 //已线下退款
      }
      if (data.refundStatusFlag === 2 || data.refundStatusFlag === 3) {
        statusId = 8 //退款中
      }
      if ([4, 7, 8].includes(data.refundStatusFlag)) {
        statusId = 9 //退款成功
      }
    }
  }

  if (data.orderTypeFlag === 3) {
    // submitTypeFlag":{1：到店订单 2：在线下单}
    let orderStatusArr = null
    if (data.submitTypeFlag === 1) {
      // 待扫码确认2  已取消4   待完成5  待支付1  已完成6  交易关闭3
      orderStatusArr = [0, '2', '4', '5', '1', '6', '3']
      statusId = orderStatusArr[data.orderStatusFlag]
    }
    if (data.submitTypeFlag === 2) {
      //待支付1  已取消4  待完成5  已完成6  退款待确认7 退款中8 退款成功9 交易关闭3
      orderStatusArr = [0, '1', '4', '5', '6', '7', '8', '9', '3']
      statusId = orderStatusArr[data.orderStatusFlag]
    }
    // console.log(data.orderNo, data.orderStatusFlag);
  }
  // 服务合约
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)) {
    // 待支付 1 //已取消 2 //待激活 3 //已激活 9 //退款中（含超时情况）4 //订单关闭(已退款) 13 //已退货 14
    statusId = data.orderStatusFlag
    // console.log(data.orderNo, data.orderStatusFlag);
  }

  return statusId
}

// 订单状态配置
const getOderStatusConf = (statusId, data) => {
  let typeFlag = data.orderTypeFlag || 1
  // 致友计划
  /*
  退款状态标识 refundStatusFlag{ 1：待经销商确认 2：经销商已确认退款（退款中） 3：超时自动退款（退款中） 4：退款成功  5：退款失败  6:客户撤销退款 7:退款成功（线下退款） }
  订单状态标识 orderStatusFlag{ 1：待支付 2：已取消（客户取消/超时自动取消） 3：待接单 4：申请退款 5：已拒单 6：已接单，待评价 7：已评价 8：已作废 }
  */
  const { planStatusConf, verifyStatusConf, tyreStatusConf, shopStatusConf } = staticConfig
  if (typeFlag === 1) {
    //不改变其他逻辑 新增意向金显示内容
    if (data.payTypeFlag == 3 && statusId == 3) {
      return {
        en: 'awaitAccept',
        zh: '待预约',
        icon: 'underway-o'
      }
    }
    return planStatusConf[statusId] || {}
  }
  if (typeFlag === 2 || typeFlag === 4) {
    return verifyStatusConf[statusId] || {}
  }
  if (typeFlag === 3) {
    return tyreStatusConf[statusId] || {}
  }
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(typeFlag)) {
    if ((typeFlag == EWOrderTypeFlag && statusId === 2 && data.refundTime) || (typeFlag == EWOrderTypeFlag && data.orderStatus?.key === 14)) {
      return shopStatusConf[13] || {}
    }
    return shopStatusConf[statusId] || {}
  }
  return {}
}

// 订单头部状态数据
const getStatusData = (data, statusId) => {
  //退款步骤,组件使用index
  let refundStatusConfig = {
    // val  :  index
    '1': '0',
    '2': '1',
    '3': '1',
    '4': '2',
    '5': '2',
    '7': '2'
  }
  let configStatusData = getOderStatusConf(statusId, data)
  let defaultStatusData = {
    en: '', //英文标识
    zh: '', //中文
    icon: '',
    residueTime: data.countdown > 0 && data.countdown * 1000, //支付剩余时间
    statusDesc: configStatusData && (configStatusData.statusDesc || configStatusData.zh), //状态描述
    returnTime: data.countdown > 0 && data.countdown * 1000, //自动退回时间
    //退款步骤
    active: data.refundStatusFlag && refundStatusConfig[data.refundStatusFlag],
    showActive: data.refundStatusFlag === 6 ? false : Boolean(data.refundStatusFlag), //显示退款
    refundStatusFlag: data.refundStatusFlag,
    failReason: data.profile //失败原因
  }

  // console.log(configStatusData,statusId,'orderStatusFlag-->',data.orderStatusFlag,'refundStatusFlag-->',data.refundStatusFlag)
  let optionStatusData = {}
  // 计划订单特殊处理
  if (data.orderTypeFlag === 1) {
    //默认“交易关闭”
    if (data.orderStatusFlag == 2 && data.cancelReason == 2) {
      //cancelReason 1:超时未支付取消 2:用户取消
      optionStatusData.icon = 'info-o'
      optionStatusData.statusDesc = '已取消'
      optionStatusData.zh = '已取消'
    }
  }
  // 核销订单特殊处理
  if (data.orderTypeFlag === 2 || data.orderTypeFlag === 4) {
    //默认“交易关闭”
    if (data.orderStatusFlag == 2 && (data.cancelReason == 2 || data.cancelReason == 3)) {
      //cancelReason 1:超时未支付取消 2:用户取消,3经销商取消
      optionStatusData.icon = 'info-o'
      optionStatusData.statusDesc = '已取消'
      optionStatusData.zh = '已取消'
    }
  }
  // 轮胎订单特殊处理
  if (data.orderTypeFlag === 3) {
    //默认“已取消”
    if (data.orderStatusFlag == 2 && data.cancelReason == 1) {
      //cancelReason 1:超时未支付取消 2:用户取消,3经销商取消
      optionStatusData.icon = 'info-o'
      // 超时未支付，交易自动关闭
      optionStatusData.statusDesc = '已取消'
      optionStatusData.zh = '已取消'
    }
    if (configStatusData.en === 'closeOrder') {
      let param = [data.productInfo, [4, 7], 'refundStatusFlag']
      let isCandelete = getBoolByServiceOrderStatusFlag(...param)
      //cancelReason 1:超时未支付取消 2:用户取消,3经销商取消
      if (isCandelete || [4, 7].includes(data.refundStatusFlag)) {
        optionStatusData.showDeleteIcon = true
      }
    }
    // minimall订单只展示信息
    if (data.miniMallOrder === 1) {
      optionStatusData.icon = 'info-o'
      optionStatusData.failReason = ''
      optionStatusData.showActive = false
      optionStatusData.showDeleteIcon = false
      optionStatusData.en = data.orderStatusName ? 'miniMallOrder' : ''
      optionStatusData.zh = optionStatusData.statusDesc = data.orderStatusName || ''
    }
  }
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFla)) {
    //默认
    if (data.orderStatusFlag == 2 && data.cancelReason == 1) {
      //cancelReason 1:超时未支付取消 2:用户取消,3经销商取消
      optionStatusData.icon = 'info-o'
      // 超时未支付，交易自动关闭
      optionStatusData.statusDesc = '超时未支付，交易关闭'
      optionStatusData.zh = '已取消'
    }
  }
  if (data.orderTypeFlag === EWOrderTypeFlag) {
    if ([13, 14].includes(data.orderStatus?.key)) {
      optionStatusData.showActive = false
      optionStatusData.refundMessage = '请联系经销商核实退款到账情况'
    }
  }
  return Object.assign(defaultStatusData, configStatusData, optionStatusData)
}
// 姓名加密处理：显示第1个字，后面都隐藏
const maskCustomerName = name => {
  if (!name || typeof name !== 'string') return ''
  if (name.length === 1) return name
  return name.charAt(0) + '**'
}

// 手机号加密处理：显示前3位和后4位，中间隐藏
const maskMobileNumber = mobile => {
  if (!mobile || typeof mobile !== 'string') return ''
  if (mobile.length < 7) return mobile // 长度不足7位的不处理
  if (mobile.length === 11) {
    // 标准11位手机号：139****5555
    return mobile.substring(0, 3) + '****' + mobile.substring(7)
  }
  // 其他长度的手机号也按照前3位后4位的规则处理
  const frontPart = mobile.substring(0, 3)
  const backPart = mobile.substring(mobile.length - 4)
  return frontPart + '****' + backPart
}

// 详情周边数据
const getDetailData = (data = {}) => {
  let detailData = []
  const isFromConsumption = data && data._from === 'consumption'

  // 基础信息
  let baseData = [
    {
      name: data.orderTypeFlag === 1 ? '购买经销商信息' : '经销商信息',
      data: [
        { label: data.orderTypeFlag === 2 ? '使用经销商' : '经销商', value: data.dealer && data.dealer.name },
        {
          label: '经销商电话',
          value: data.dealer && data.dealer.tel,
          icon: 'phone',
          type: 'icon'
        },
        {
          label: '服务顾问',
          value: CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)
            ? false
            : `${data.dealer && data.dealer.boUserName} / ${data.dealer && data.dealer.boUserMobile}`
        },
        {
          label: '可使用经销商',
          value: [1, 6, 9, 10, EWOrderTypeFlag].includes(data.orderTypeFlag) ? '点击查看' : false,
          key: 'viewUseDealer',
          underline: true
        }
      ]
    },
    {
      name: '联系人信息',
      en: 'contact',
      data: [
        { label: '姓名', value: maskCustomerName(data.contactName) },
        { label: '手机号', value: maskMobileNumber(data.contactMobile) }
      ]
    },
    {
      name: '车辆信息',
      data: [
        { label: '车型', value: data.carInfo && data.carInfo.model },
        { label: '车牌号', value: (data.carInfo && data.carInfo.plate) || '暂无' },
        { label: 'VIN', value: (data.carInfo && data.carInfo.vin) || '暂无' },
        { label: 'FIN', value: (data.carInfo && data.carInfo.fin) || '暂无' }
        // {
        //   label: '三包日期',
        //   value: (data.carInfo && data.carInfo.threeGuaranteesDate && addEightHour(data.carInfo.threeGuaranteesDate, 'day')) || '暂无'
        // },
        // {
        //   label: '车龄',
        //   value: data.carInfo && data.carInfo.carAge ? `${data.carInfo && data.carInfo.carAge}年` : data.carInfo && data.carInfo.carAge === 0 ? '新车' : '暂无'
        // }
      ]
    }
  ]

  // 获取权益信息
  const getRightInfo = () => {
    let plan = (data.vertificationInfo && data.vertificationInfo.plan) || {}
    let coupon = (data.vertificationInfo && data.vertificationInfo.coupon) || {}
    let couponObj = couponList([coupon])[0]
    let thresholdStr = couponObj.thresholdStr == '无使用门槛' ? '' : `${couponObj.thresholdStr}`
    let couponContent = thresholdStr ? `${couponObj.discountStr} ( ${thresholdStr} )` : `${couponObj.discountStr}`
    return {
      name: '权益信息',
      data: [
        { label: '计划名称', value: plan.loyaltyName },
        { label: '权益名称', value: coupon.rightName },
        {
          label: '券编码',
          value: data.vertificationInfo && data.vertificationInfo.couponCode
        },
        { label: '权益券类型', value: couponObj.typeName },
        { label: '权益优惠内容', value: couponContent }
      ]
    }
  }

  // 获取优惠券信息
  const getDiscountInfo = () => {
    let coupon = (data.vertificationInfo && data.vertificationInfo.coupon) || {}
    let couponObj = couponList([coupon])[0]
    let thresholdStr = couponObj.thresholdStr == '无使用门槛' ? '' : `${couponObj.thresholdStr}`
    let couponContent = thresholdStr ? `${couponObj.discountStr} (${thresholdStr})` : `${couponObj.discountStr}`
    return {
      name: '优惠券信息',
      data: [
        { label: '优惠券名称', value: coupon.rightName },
        {
          label: '券编码',
          value: data.vertificationInfo && data.vertificationInfo.couponCode
        },
        { label: '优惠券类型', value: couponObj.typeName },
        { label: '优惠券内容', value: couponContent }
      ]
    }
  }

  // 获取订单信息
  const getOrderInfo = () => {
    // orderTypeFlag=》 1：计划订单 2：权益券核销订单 3：轮胎订单 4.优惠券核销订单
    let orderAmountTemp = isNum(+data.orderAmount) ? `¥${data.orderAmount}` : ''
    // 核销订单类型
    if (data.orderTypeFlag === 2 || data.orderTypeFlag === 4) {
      // originalPrice 修改前价格  orderAmount 修改后价格
      const { originalPrice, orderAmount } = data
      orderAmountTemp = orderAmount === originalPrice ? `¥${orderAmount}` : `¥${orderAmount} / ¥${originalPrice}`
    }
    if (isFromConsumption) {
      orderAmountTemp = false
    }
    const getPayNum = data => {
      if (isFromConsumption) {
        return false
      }
      if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)) {
        return false
      }
      //LPO-4676，计划订单线下付款金额显示横线
      let value = isNum(+data.payAmount) ? `¥${data.payAmount}` : ''
      if (data.orderTypeFlag === 1 && data.payMethodFlag === 3) {
        value = '—'
      }
      return value
    }
    const getDiscountNum = data => {
      if (isFromConsumption) {
        return false
      }
      let value = isNum(data.discountAmount) && data.discountAmount > 0 ? `- ¥${data.discountAmount}` : false
      return value
    }
    const getContractPrice = data => {
      if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)) {
        return `¥${data.products[0]?.productPrice || '-'}`
      }
      return false
    }
    const getCustomerRemark = data => {
      if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)) {
        return `${data.products[0]?.customerRemark || '-'}`
      }
      return false
    }
    return {
      name: '订单信息',
      data: [
        { label: '订单编号', value: data.orderNo, icon: 'copy', src: copyImg },
        { label: '退款流水号', value: data.refundNo || false },
        { label: '下单时间', value: data.orderTypeFlag === EWOrderTypeFlag ? data.orderTime : addEightHour(data.orderTime) },
        { label: '支付时间', value: data.orderTypeFlag === EWOrderTypeFlag ? data.payTime || false : addEightHour(data.payTime) || false },
        { label: '激活时间', value: data.orderTypeFlag === EWOrderTypeFlag ? data.activeTime || false : addEightHour(data.activeTime) || false },
        {
          label: '申请退款时间',
          value: CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag) ? false : addEightHour(data.refundApplyTime) || false
        },
        {
          label: '退款发起时间',
          value: data.orderTypeFlag === EWOrderTypeFlag ? data.refundStartTime || false : addEightHour(data.refundStartTime) || false
        },
        {
          label: '退款完成时间',
          value: data.orderTypeFlag === EWOrderTypeFlag ? data.refundFinishTime || false : addEightHour(data.refundFinishTime) || false
        },
        {
          label: '退货时间',
          value: CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)
            ? (data.orderTypeFlag === EWOrderTypeFlag ? data.returnAuditTime || false : addEightHour(data.returnAuditTime)) || false
            : false
        },
        { label: '接单时间', value: data.acceptTime ? (data.orderTypeFlag === EWOrderTypeFlag ? data.acceptTime : addEightHour(data.acceptTime)) : false },
        { label: '取消时间', value: data.cancelTime ? (data.orderTypeFlag === EWOrderTypeFlag ? data.cancelTime : addEightHour(data.cancelTime)) : false },
        { label: '拒单时间', value: data.rejectTime ? (data.orderTypeFlag === EWOrderTypeFlag ? data.rejectTime : addEightHour(data.rejectTime)) : false },
        { label: '作废时间', value: data.voidTime ? (data.orderTypeFlag === EWOrderTypeFlag ? data.voidTime : addEightHour(data.voidTime)) : false },
        { label: '完成时间', value: CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag) ? false : addEightHour(data.finishTime) || false },
        // { label: '激活时间', value: data.orderTypeFlag === 6 ? addEightHour(data.finishTime) || false : false },
        { label: '付款方式', value: data.payMethodName || false },
        { label: '零售价', value: getContractPrice(data) },
        { label: data.payTypeFlag == 3 ? '意向金金额' : '订单金额', value: orderAmountTemp },
        {
          label: '优惠金额',
          value: getDiscountNum(data)
        },
        {
          label: '支付金额',
          //LPO-4676，计划订单线下付款金额加横线
          // line: data.orderTypeFlag === 1 && data.payMethodFlag === 3,
          value: getPayNum(data)
        },
        { label: '备注', value: getCustomerRemark(data) },
        {
          label: '预约时间',
          //LPO-5559，商城订单关联的预约记录为“等待到达”，商城订单详情显示预约时间
          value: data.orderTypeFlag === 1 && data.oabStatus && data.oabInfo && data.oabInfo.status === '10New' ? data.oabInfo.bookedDate : false
        }
      ]
    }
  }

  // 产品清单
  const getProductList = () => {
    let products = data.products || []
    return {
      name: '产品清单',
      en: 'productsList',
      type: 'longLabel',
      data: products.map(item => ({
        label: `${item.productTypeName || '无产品类型'}- ${item.productName || '无产品名称'}- ${item.productId || '无产品编号'}`,
        value: {
          productPrice: item.productPrice ? `¥${item.productPrice}` : '',
          productAmount: item.productAmount ? `×${item.productAmount}` : ''
        }
      }))
    }
  }

  // 轮胎订单信息
  const getTypeOrderInfo = () => {
    // submitTypeFlag":{1：到店订单 2：在线下单}
    let getSubmitType = () => {
      let label = '服务类型'
      let value = false
      let submitTypeArr = ['', '到店', '在线预约']
      if (data.submitTypeFlag && submitTypeArr[data.submitTypeFlag]) {
        value = `【${submitTypeArr[data.submitTypeFlag]}】轮胎快修服务`
      }
      return { label, value }
    }
    let isZero = data.payAmount === 0
    let getPayAmount = () => {
      let label = ''
      let res = []
      if (data.submitTypeFlag === 1) {
        // 到店
        label = data.orderStatusFlag === 4 || !data.payMethodFlag ? '应付金额' : '实付金额'
      }
      if (data.submitTypeFlag === 2) {
        // 在线预约
        label = data.orderStatusFlag === 1 || !data.payMethodFlag ? '应付金额' : '实付金额'
      }
      if (isZero) {
        label = '实付金额'
      }
      res = [
        {
          label,
          value: isNum(+data.payAmount) ? `¥ ${data.payAmount}` : ''
        }
      ]
      if (data.miniMallOrder === 1) {
        res = [
          {
            label: '意向金',
            value: data.depositAmount && data.depositAmount > 0 ? `¥ ${data.depositAmount}` : false
          }
        ]
      }
      return res
    }
    let getDiscountAmount = () => {
      let { couponInfo } = data
      let couponList = null
      let couponCode = []
      // "优惠券类别{1:商城轮胎券 2:六位码优惠券}"
      let couponTypeFlag = couponInfo && couponInfo[0] ? couponInfo[0].couponTypeFlag : ''
      if (couponTypeFlag === 1) {
        couponList = couponInfo.map(({ couponContent }) => couponContent)
      }
      if (couponTypeFlag === 2) {
        couponCode = couponInfo.map(({ couponCode }) => couponCode)
      }
      return {
        label: '优惠金额',
        en: 'discount',
        couponList,
        couponCode: couponCode.join(),
        value: isNum(data.discountAmount) && data.discountAmount > 0 ? `- ¥${data.discountAmount}` : false
      }
    }
    let getOrderDiscountPrice = value => {
      if (value === 0) {
        return false
      } else if (value > 0) {
        return ` ￥${value}`
      } else if (value < 0) {
        value = Math.abs(value)
        return `- ￥${value}`
      }
    }
    return {
      data: [
        getSubmitType(),
        {
          label: '经销商',
          value: data?.dealer?.name || ''
        },
        {
          label: '经销商电话',
          value: data?.dealer?.tel || '',
          icon: 'phone',
          type: 'icon'
        },
        {
          label: '经销商地址',
          value: data?.dealer?.address || ''
        },
        {
          label: '车主姓名',
          value: maskCustomerName(data.customerName) || ''
        },
        {
          label: '车主手机号',
          value: maskMobileNumber(data.customerMobile) || ''
        },
        {
          label: '车牌号',
          value: (data.miniMallOrder === 1 ? data.plate : data?.carInfo?.plate) || ''
        },
        {
          label: '轮胎照片',
          type: 'imgArr',
          // imgArr: data.tyrePhoto.map(item => item.localData),
          imgArr: data.thumbnail,
          value: data.tyrePhoto && data.tyrePhoto.length ? '' : '未上传照片'
        },
        // 以下是轮胎订单信息
        { label: '订单编号', value: data.orderNo, icon: 'copy', src: copyImg },
        { label: '下单时间', value: addEightHour(data.orderTime) },
        { label: '支付时间', value: isZero ? '-' : addEightHour(data.payTime) || false },
        { label: '取消时间', value: addEightHour(data.cancelTime) || false },
        { label: '支付方式', value: isZero ? '-' : data.payMethodName || false },
        {
          label: data.miniMallOrder === 1 ? '厂商建议零售价' : '订单金额',
          value: isNum(+data.orderAmount) ? ` ¥ ${data.orderAmount}` : ''
        },
        getDiscountAmount(),
        { label: '折扣金额', value: isNum(data.orderDiscountPrice) ? getOrderDiscountPrice(data.orderDiscountPrice) : false },
        ...getPayAmount()
      ]
    }
  }

  const getEffectiveTime = data => {
    let products = data.products || []
    let product = products.length ? products[0] : {}
    // console.log('getActiveTime--', data)
    let res = []
    let start =
      data.orderTypeFlag === EWOrderTypeFlag
        ? product?.effectiveBaseDate || false
        : (product?.effectiveBaseDate && addEightHour(product?.effectiveBaseDate.slice(0))) || false
    let end =
      data.orderTypeFlag === EWOrderTypeFlag
        ? product?.effectiveEndDate || false
        : (product?.effectiveEndDate && addEightHour(product?.effectiveEndDate.slice(0))) || false
    start && res.push(start)
    end && res.push(end)
    let str = ''
    if (start && end) {
      str = res.join(' 至 ')
    } else if (start) {
      str = `从 ${start} 起`
    } else {
      str = ''
    }
    // 已激活的订单详情 增加合同有效期字段。（展示起止日期）
    if (data.orderStatusFlag != 9) {
      start = false
      end = false
    }
    return { str, start, end }
  }

  const getContractInfo = () => {
    console.log('datadatadatadatadatadatadata', data)
    const arr = [
      {
        label: '合同编号',
        value: data.products[0]?.contractCode || '暂无'
      }
    ]
    if (data.orderTypeFlag === 101 && data.products[0]?.productType !== 'PRD_CATEGORY_17') {
      arr.push({
        label: '合同开始时间',
        value: getEffectiveTime(data)?.start,
        tip: '（如因特殊原因涉及变更，请咨询经销商确认）'
      })
      arr.push({
        label: '合同结束时间',
        value: getEffectiveTime(data)?.end,
        tip: '（如车辆行驶里程先于产品结束日期达到产品结束时车辆总行驶里程，以该时间为产品结束日期）'
      })
    } else {
      arr.push({
        label: '合同开始时间',
        value: getEffectiveTime(data)?.start
      })
      arr.push({
        label: '合同结束时间',
        value: getEffectiveTime(data)?.end
      })
    }
    arr.push({
      label: '产品告知书',
      value: '点击查看',
      key: 'viewContract',
      underline: true
    })
    return {
      name: '合同信息',
      data: arr
    }
  }
  // 致友计划订单类型
  if (data.orderTypeFlag === 1) {
    const customer = {
      name: '客户信息',
      en: 'contact',
      data: [
        { label: '姓名', value: maskCustomerName(data.customerName) },
        { label: '手机号', value: maskMobileNumber(data.customerMobile) }
      ]
    }
    let temp = baseData.map(item => (item.en === 'contact' ? customer : item))
    detailData = [...temp, getOrderInfo()]
  }
  // 计划核销订单类型
  if (data.orderTypeFlag === 2) {
    // detailData = [...baseData, getRightInfo(), getOrderInfo(), getProductList()]
    // UAT-3958，不展示权益核销产品清单
    detailData = [...baseData, getRightInfo(), getOrderInfo()]
  }
  // 轮胎订单
  if (data.orderTypeFlag === 3) {
    detailData = [getTypeOrderInfo()]
  }
  // 优惠券核销
  if (data.orderTypeFlag === 4) {
    detailData = [...baseData, getDiscountInfo(), getOrderInfo(), getProductList()]
  }

  // 服务合约
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(data.orderTypeFlag)) {
    detailData = [...baseData, getOrderInfo(), getContractInfo()]
  }
  //新增 意向金 无车型  不显示车型
  if (data.carInfo.customerCarId == -1) {
    const index = detailData.findIndex(item => item.name == '车辆信息')
    detailData.splice(index, 1)
  }

  return detailData
}
// 详情订单商品信息
const getProductsData = (datas = {}, statusDatas) => {
  // orderTypeFlag=》 1：计划订单 2：权益券核销订单 3：轮胎订单 4.优惠券核销订单
  let data = []
  if (datas.orderTypeFlag === 3) {
    data = datas.productInfo ? (datas.miniMallOrder === 1 ? [datas.productInfo] : datas.productInfo) : []
    return data.map(item => {
      let productName = datas.miniMallOrder === 1 ? item.productName : reorganizeTyreName(item)
      let { btnData, flag, name, statusData } = getServiceInfoInTyreOrder(item, { scene: 'detail', datas, len: data.length, statusDatas })
      btnData = btnData && {
        ...btnData,
        _data: datas,
        _item: item
      }
      if (datas.submitTypeFlag === 2 && [5, 6].includes(datas.orderStatusFlag)) {
        name = ''
      }
      return {
        ...item,
        imgSrc: typeImg,
        name: productName.trim(),
        productName: productName.trim() || '暂无名称',
        // 本单售价/自主定价
        price: getTypePrice(item),
        num: item.productAmount,
        dealerName: '',
        carInf: ``,
        orderTypeFlag: datas.orderTypeFlag,
        btnData: btnData && [btnData],
        statusData,
        currentStatus: name,
        currentStatusFlag: flag,
        miniMallOrder: datas.miniMallOrder
      }
    })
  } else if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(datas.orderTypeFlag)) {
    data = datas.products || []
    return data.map(item => {
      return {
        ...item,
        thumbnail: item?.thumbnail,
        productName: datas?.productsName,
        productNames: datas?.productsNames,
        dealerName: datas?.dealer?.name,
        carText: '',
        miniMallOrder: datas.miniMallOrder,
        copyImg: { value: datas.orderNo, icon: 'copy', src: copyImg }
      }
    })
  } else {
    data = datas.products
    return data.map(item => {
      let imgSrc = ''
      if (datas.orderTypeFlag === 1) {
        imgSrc = (item.planImage && item.planImage[0] && item.planImage[0].imageUrl) || ' '
      }
      if (datas.orderTypeFlag === 2 || datas.orderTypeFlag === 4) {
        imgSrc = false
      }
      return {
        ...item,
        imgSrc,
        name: item.productName,
        price: item.productPrice,
        orderTypeFlag: datas.orderTypeFlag,
        num: item.productAmount
      }
    })
  }
}

// 组合轮胎名称
export const reorganizeTyreName = product => {
  // 产地+品牌+原配+规格+载重指数+速度级别+加大载重+花纹
  let productName = `${(product.brand && product.brand.name) || ''}\xa0\xa0${product.moe ? '原配' + product.moe : ''} ${product.spec ||
    ''} ${product.loadIndex || ''}${product.speedRating || ''} ${product.extraLoad || ''}${product.pattern || ''}`
  return productName
}

const getServiceInfoInTyreOrder = (proItem, option = {}) => {
  // 服务订单状态{2：待接单备货 11：备货中 3：待完成服务 4：待确认完成  5：已完成6：已取消}
  // 退款状态标识{1：待经销商确认 2：经销商已确认退款（退款中） 3：超时自动退款（退款中） 4：退款成功 5：退款失败  6:客户撤销退款 7:退款成功（线下退款）}
  let btnData = null
  let serviceOrderInfo = proItem.serviceOrderInfo || {}
  // console.log("serviceOrderInfo", serviceOrderInfo);
  let {
    serviceOrderStatusFlag: flag = '',
    serviceOrderStatusName: name = '',
    refundStatusFlag = '',
    refundStatusFlagName = '',
    refundAmount = 0
  } = serviceOrderInfo
  let statusData = { refundStatusFlag, price: refundAmount }
  if (flag === 7) {
    //兼容服务订单退款状态
    flag = 2
    name = '待接单备货'
  }
  if (refundStatusFlag == 2 || refundStatusFlag == 3) {
    // "退款中"
    // name = refundStatusFlagName
    statusData.active = 1
    statusData.showActive = true
  }
  if (refundStatusFlag == 4) {
    // "退款成功"
    // name = refundStatusFlagName
    statusData.active = 2
    statusData.showActive = true
  }
  if (refundStatusFlag == 5) {
    // "退款失败"
    // name = refundStatusFlagName
    statusData.active = 2
    statusData.showActive = true
  }
  if (proItem.productPrice === 0) {
    // 0元订单，不显示退款详情的进度条
    statusData = null
  }
  if (refundAmount === 0 || refundAmount === null) {
    // 退款金额0，不显示退款详情的进度条
    statusData = null
  }
  // if (flag === 4) {
  //   btnData = { text: "确认完成", btnId: "88", type: "active" };
  //   name = "";
  // }
  let { scene, len, datas, statusDatas } = option
  //待完成&&预约&&多条服务订单&&待接单备货
  // console.log(scene, len, datas)
  if (statusDatas && statusDatas.en === 'awaitFinished' && datas.submitTypeFlag === 2 && scene === 'detail' && len > 1 && flag === 2) {
    if ((!refundStatusFlag || refundStatusFlag === 6) && proItem.productPrice > 0 && datas.payAmount > 0) {
      //无退款状态可申请退款/客户撤销退款
      btnData = applyServiceRefundBtn
    }
    if (refundStatusFlag === 1) {
      //1：退款待经销商确认，可取消退款
      btnData = cancelServiceRefundBtn
      name += `,${refundStatusFlagName}`
    }
  }
  return { btnData, flag, name, statusData }
}

// 列表订单商品信息
const getListProductsData = listItem => {
  // orderTypeFlag=》 1：计划订单 2：权益券核销订单 3：轮胎订单 4.优惠券核销订单 6.保养套餐 7.礼包 9.NEV 10.易损件
  const orderTypeFlag = listItem.orderTypeFlag
  let miniMallOrder = listItem.miniMallOrder
  if (orderTypeFlag === 1) {
    let data = listItem.products || []
    let carInf = `${listItem.carInfo.plate || '暂无车牌'}  |  ${listItem.carInfo.model || '暂无车型'} `
    if (listItem.payTypeFlag == 3) {
      carInf = '暂不选择车辆'
    }
    return data.map(product => {
      return {
        ...product,
        imgSrc: (product.planImage && product.planImage[0] && product.planImage[0].imageUrl) || ' ',
        name: product.productName,
        price: product.productPrice,
        num: product.productAmount,
        dealerName: listItem.dealer && listItem.dealer.name,
        carInf,
        orderTypeFlag,
        miniMallOrder,
        payTypeFlag: listItem.payTypeFlag,
        oabStatus: listItem.oabStatus,
        oabInfo: listItem.oabInfo
      }
    })
  }
  if (orderTypeFlag === 2 || orderTypeFlag === 4) {
    // console.log("核销订单-->", listItem.orderNo);
    let imgSrc = orderTypeFlag === 2 ? verifyImg : orderTypeFlag === 4 ? discountImg : ''
    return [
      {
        ...listItem,
        imgSrc,
        name: '',
        orderId: listItem.id,
        productName: `订单编号:${listItem.orderNo}`,
        price: '',
        num: '',
        dealerName: listItem.dealer && listItem.dealer.name,
        carInf: `${listItem.carInfo.plate || '暂无车牌'}  |  ${listItem.carInfo.model || '暂无车型'} `,
        orderTypeFlag: orderTypeFlag,
        hiddenPrice: true
      }
    ]
  }
  if (orderTypeFlag === 3) {
    // console.log("轮胎订单-->", listItem.orderNo, listItem);
    let imgSrc = typeImg
    let data = listItem.productInfo ? (miniMallOrder === 1 ? [listItem.productInfo] : listItem.productInfo) : []
    return data.map(product => {
      let productName = miniMallOrder === 1 ? product.productName : reorganizeTyreName(product)
      let { btnData, flag, name, statusData } = getServiceInfoInTyreOrder(product, { scene: 'list', datas: listItem, len: data.length })
      btnData = btnData && {
        ...btnData,
        _data: listItem,
        _item: product
      }
      // 需求变更--列表商品信息不再展示退款进度
      statusData = { showActive: false, active: 1 }
      //UAT-4150 4059  2021-04-22 潘静 当商城订单（预约订单）是退款待确认5，退款中6 时，不显示服务订单的状态
      if (listItem.submitTypeFlag === 2 && [5, 6].includes(listItem.orderStatusFlag)) {
        name = ''
      }
      return {
        ...product,
        imgSrc: imgSrc,
        name: productName.trim(),
        productName: productName.trim() || '暂无名称',
        // 本单售价
        price: getTypePrice(product),
        num: product.productAmount,
        dealerName: '',
        carInf: ``,
        orderTypeFlag,
        btnData: (btnData && [btnData]) || [],
        statusData,
        currentStatus: name,
        currentStatusFlag: flag,
        miniMallOrder
      }
    })
  }
  return [
    {
      ...listItem,
      imgSrc: '',
      name: '',
      orderId: listItem.id,
      productName: '',
      price: '',
      num: '',
      dealerName: '',
      carInf: '',
      orderTypeFlag: listItem.orderTypeFlag
    }
  ]
}

// 消费明细列表商品信息
const getConsumptionListProductsData = listItem => {
  return {
    ...listItem,
    imgSrc: verifyImg,
    productName: `订单编号:${listItem.orderNo}`,
    dealerName: (listItem.dealer && listItem.dealer.name && `使用经销商：${listItem.dealer.name}`) || '',
    carInf: `${listItem.carInfo.plate || ''}  |  ${listItem.carInfo.model || ''} `,
    orderTypeFlag: listItem.orderTypeFlag
  }
}

// 列表订单tab状态信息
const setListItemStatusActive = listItem => {
  /*
  1待支付，所有待支付订单 orderStatusFlag 1
  2待完成，所有待接单订单 orderStatusFlag 3
  3待评价，所有已接单但未评价的订单  orderStatusFlag  6
  4退款/售后，--|
            退款状态为待经销商确认/退款中的订单 refundStatusFlag  1/2/3
            已作废orderStatusFlag 8
  */
  const tabStatusConfig = {
    // key:orderStatusFlag      val:statusActive
    '1': 1,
    '3': 2,
    '6': 3,
    '8': 4
  }
  let statusActive = tabStatusConfig[listItem.orderStatusFlag]
  if ([1, 2, 3, 4, 5].includes(listItem.refundStatusFlag)) {
    statusActive = 4
  }
  return statusActive
}

const getOtherOption = item => {
  // submitTypeFlag":{1：到店订单 2：在线下单}
  let explain = ''
  let reserveTime = ''
  let totalNum = item.payAmount
  let _component = ''
  if (item.orderTypeFlag === 3) {
    if (item.reserveTime) {
      moment.locale('zh-cn', {
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_')
      })
      reserveTime = moment(item.reserveTime)
        .add(8, 'hours')
        .format(`YYYY-MM-DD dddd HH:mm:ss`)
    }
    explain = '最终实际成交价格以所选梅赛德斯-奔驰授权经销商零售价格为准。'
    //submitTypeFlag":{1：到店订单 2：在线下单}
    if (item.miniMallOrder === 1 && item.submitTypeFlag === 2) {
      totalNum = item.depositAmount
    }
    if (item.miniMallOrder === 1 && item.submitTypeFlag === 1) {
      totalNum = item.orderAmount
    }
  }
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(item.orderTypeFlag)) {
    _component = 'ShopCard'
  }

  return {
    _component,
    totalNum,
    explain,
    reserveTime
  }
}

//组合订单列表数据
export const reorganizeListData = data => {
  // console.log(data)
  // data.unshift({ ...data[0], orderTypeFlag: 6, _component: 'ShopCard', orderStatusFlag: 3 })
  return data.map(item => {
    // 申请退款和拒单会有退款状态
    let statusId = getStatusId(item)
    // 头部状态数据
    const statusData = getStatusData(item, statusId)
    // 订单tab状态信息
    const statusActive = setListItemStatusActive(item)
    // 订单商品信息
    let productsData = getListProductsData(item)
    // 底部按钮
    let btnData = getBottomBtn(statusId, {
      orderTypeFlag: item.orderTypeFlag,
      _data: item
    })
    // 额外信息处理
    let other = getOtherOption(item)
    return {
      ...item,
      statusActive,
      creatTime: item.orderTypeFlag === EWOrderTypeFlag ? item.orderTime : addEightHour(item.orderTime),
      oderStatus: statusId,
      residueTime: item.countdown > 0 && item.countdown * 1000,
      productsData,
      statusData,
      btnData: btnData.map(btnItem => Object.assign(btnItem, { _data: item })),
      ...other
    }
  })
}

//组合消费明细数据
export const reorganizeConsumptionListData = data => {
  // console.log(data)
  return data.map(item => {
    // 申请退款和拒单会有退款状态
    let statusId = getStatusId(item)
    // 头部状态数据
    const statusData = getStatusData(item, statusId)
    // 订单商品信息
    let productsData = getConsumptionListProductsData(item)
    // 底部按钮
    let btnData = getBottomBtn(statusId, { orderTypeFlag: item.orderTypeFlag })
    return {
      ...item,
      creatTime: addEightHour(item.orderTime),
      totalNum: item.orderAmount,
      oderStatus: statusId,
      residueTime: item.countdown > 0 && item.countdown * 1000,
      productsData,
      statusData: Object.assign(statusData, { showDeleteIcon: false }),
      btnData: btnData.map(btnItem => Object.assign(btnItem, { _data: item }))
    }
  })
}

// 组合订单详情数据
export const reorganizeDetailData = data => {
  let statusId = getStatusId(data)
  // 详情头部状态数据
  const statusData = getStatusData(data, statusId)
  // 订单商品信息
  let productsData = getProductsData(data, statusData)
  // 详情周边数据
  let detailData = getDetailData(data, statusId)
  // 底部按钮
  let btnData = getBottomBtn(statusId, {
    orderTypeFlag: data.orderTypeFlag,
    _data: data
  })
  // console.log("statusData", statusData, productsData, detailData, btnData);
  return {
    statusData,
    productsData,
    detailData,
    btnData: btnData.map(btnItem => Object.assign(btnItem, { _data: data }))
  }
}
// 判断服务订单状态是否符合
const getBoolByServiceOrderStatusFlag = (data = [], everyFlag = [], flagField) => {
  everyFlag = Array.isArray(everyFlag) ? everyFlag : [everyFlag]
  data = data || []
  return data.every(({ serviceOrderInfo, cancelStatusFlag }) => {
    serviceOrderInfo = serviceOrderInfo || {}
    flagField = flagField || 'serviceOrderStatusFlag'
    // cancelStatusFlag为1，支付前取消，不校验退款状态
    if (cancelStatusFlag === 1 && flagField === 'refundStatusFlag') {
      return true
    }
    const { [flagField]: flag = '' } = serviceOrderInfo
    return flag && everyFlag.includes(flag)
  })
}

// 订单各状态的按钮配置
export const getBottomBtn = (v, option) => {
  /*退款状态标识{
    1：待经销商确认 2：经销商已确认退款（退款中）
    3：超时自动退款（退款中） 4：退款成功
    5：退款失败  6:客户撤销退款 7:退款成功（线下退款）}
     */
  const options = option || {}
  
  // 检查是否为OTR线下订单或新车销售订单
  if (options._data && isOtrOrNewCarOrder(options._data)) {
    // 对于OTR线下订单和新车销售订单，不提供操作按钮
    return []
  }
  
  const { planBtnObj, verifyBtnObj, tyreBtnObj, shopBtnObj } = staticConfig
  let statusName = getOderStatusConf(v, options).en
  let res = []
  let orderTypeFlag = options.orderTypeFlag
  if (orderTypeFlag === 1) {
    res = statusName && planBtnObj[statusName] ? planBtnObj[statusName] : []
    if (statusName === 'awaitAccept' && options._data.payAmount === 0) {
      //0元订单，只有取消订单
      res = [cancelOrderBtn]
    }
    if (statusName === 'awaitAccept' && options._data.payMethodFlag === 3) {
      // 线下付款，待接单状态无退款按钮
      res = []
    }
    if (statusName === 'awaitAccept' && options._data.sourceType === 1) {
      // LPO-5035,迁移订单，待接单状态无退款按钮    sourceType  --》 0:Servicemall 1:LPO订单
      res = []
    }
    if (['awaitAccept', 'alreadyAccept'].includes(statusName)) {
      //待接单/已接单 -->未关联预约 ||  关联的预约记录为“已取消”/“已到店”/"已迟到"，按钮为“立即预约”
      if (options._data.oabStatus === false || (options._data.oabStatus && ['20Arrived', '25Presence', '30Cancel'].includes(options._data?.oabInfo?.status))) {
        res = [...res, creatOabBtn]
      }
    }
    if (options._data.oabStatus && options._data?.oabInfo?.status === '10New') {
      // 10New  等待到达; 20Arrived  已到达; 25Presence  未到店; 30Cancel  已取消
      // 等待到达，显示预约时间，“查看预约”
      res = [...res, viewOabBtn]
    }
    if (options._data.prorateStatusFlag && options._data.prorateStatusFlag > 20) {
      // 抛账中的订单，无退款按钮(btnId -> 3)
      res = res.filter(item => item.btnId !== '3')
    }
  }
  if (orderTypeFlag === 2 || orderTypeFlag === 4) {
    res = statusName && verifyBtnObj[statusName] ? verifyBtnObj[statusName] : []
  }
  // 轮胎订单
  if (orderTypeFlag === 3) {
    //submitTypeFlag":{1：到店订单 2：在线下单}
    //服务订单状态{2：待接单备货 11：备货中 3：待完成服务 4：待确认完成  5：已完成6：已取消}
    const { _data: { submitTypeFlag = '', productInfo = [], couponInfo = [] } = {}, miniMallOrder } = option
    if (miniMallOrder === 1) {
      //minimall的订单，只展示不操作
      return []
    }
    res = statusName && tyreBtnObj[statusName] ? tyreBtnObj[statusName] : []
    let _cancelOrderBtn = _.clone(cancelOrderBtn)
    let cancelOrderBtnObj = Object.assign({}, _cancelOrderBtn, { fn: '' })

    // 到店
    if (submitTypeFlag === 1) {
      // 待支付状态1 --只有当所有服务订单"待接单备货"2时，可取消订单
      // 2021.04.08潘婧又改需求了，到店订单又不要取消按钮了（先注释，不删除代码）
      // if (v === "1") {
      //   let param = [productInfo, 2, "serviceOrderStatusFlag"];
      //   let isCanCancel = getBoolByServiceOrderStatusFlag(...param);
      //   isCanCancel && (res = [cancelOrderBtnObj, ...res]);
      // }
    }

    // 在线下单
    if (submitTypeFlag === 2) {
      // 待支付状态1 --预约订单立即支付+取消，配置只有立即支付
      if (v === '1') {
        res = [cancelOrderBtnObj, ...res]
      }
      // 待完成状态 5 到店订单不支持C端退款， 预约订单服务订单*都为*“待接单备货2“时，才支持”申请退款”
      if (v === '5' && options._data.payAmount > 0) {
        if (!(couponInfo.length && couponInfo[0].couponTypeFlag == 3)) {
          let param = [productInfo, [2], 'serviceOrderStatusFlag']
          let isCanRefund = getBoolByServiceOrderStatusFlag(...param)
          isCanRefund && (res = [applyRefundBtn, ...res])
        }
      }
    }
    // 到店+预约 ---》待完成状态 5，服务订单为”待确认完成4“或”已取消6“时，确认退款有确认完成按钮
    if (v === '5') {
      let param = [productInfo, [4, 6], 'serviceOrderStatusFlag']
      // 服务状态
      let isCanFinished = getBoolByServiceOrderStatusFlag(...param)
      // 必含至少一个待确认状态
      let hasWaitStatus = productInfo.some(({ serviceOrderInfo }) => {
        serviceOrderInfo = serviceOrderInfo || {}
        const { serviceOrderStatusFlag: flag = '' } = serviceOrderInfo
        return flag === 4
      })
      // 状态符合要求
      if (isCanFinished && hasWaitStatus) {
        // 是否有取消的订单
        let canCancelData = productInfo.filter(({ serviceOrderInfo }) => {
          serviceOrderInfo = serviceOrderInfo || {}
          const { serviceOrderStatusFlag: flag = '' } = serviceOrderInfo
          return flag === 6
        })
        // 有已取消的订单,需要检查退款状态
        if (canCancelData && canCancelData.length) {
          // 经销商点了退款，退款状态
          canCancelData = canCancelData.map(item => {
            const serviceOrderInfo =
              item.productPrice === 0 && item.serviceOrderInfo.refundStatusFlag === 0
                ? { ...item.serviceOrderInfo, refundStatusFlag: 4 }
                : item.serviceOrderInfo
            return { ...item, serviceOrderInfo }
          })
          let refundParam = [canCancelData, [4, 7], 'refundStatusFlag']
          // 状态
          let isShowFinished = getBoolByServiceOrderStatusFlag(...refundParam)
          isShowFinished && (res = [sureFinishedBtn, ...res])
        } else {
          // 没有取消的订单，直接加确认按钮
          res = [sureFinishedBtn, ...res]
        }
      }
    }
  }
  if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(orderTypeFlag)) {
    res = statusName && shopBtnObj[statusName] ? shopBtnObj[statusName] : []
    // 组合优惠订单-有订单被激活，无退款按钮，线下退款
    if (v === 3) {
      let _applyRefundBtn_ = _.clone(applyRefundBtn)
      let shopApplyRefundBtn = Object.assign({}, _applyRefundBtn_, { text: '退款' })
      if (options._data.discountGroupId) {
        // discountGroupActivedFlag：0无订单激活1有订单激活
        if (options._data.discountGroupActivedFlag === 0) {
          let _applyRefundBtn = _.clone(shopApplyRefundBtn)
          let _applyRefundBtnObj = Object.assign({}, _applyRefundBtn, { fn: '', customDialog: true, text: '退款' })
          res = [_applyRefundBtnObj, ...res]
        }
      } else {
        if ([EWOrderTypeFlag].includes(orderTypeFlag) && options._data?.payAmount === 0) {
          // 0元订单展示"取消订单"
          res = [...res, cancelOrderBtn]
        } else {
          // 按钮顺序要求改变
          res = orderTypeFlag === EWOrderTypeFlag ? [...res, shopApplyRefundBtn] : [shopApplyRefundBtn, ...res]
        }
      }
    }
    if (v === 1 && orderTypeFlag !== 6) {
      res = res.map(item => ({ ...item, fn: item.btnId === '1' ? 'cancelOrder' : item.fn }))
    }
  }
  return res.map(item => ({ ...item, statusNum: v, statusName, ...options }))
}

// 按钮回调统一调用
export const btnCallBack = async (v, param) => {
  if (v.type == 'disabled') {
    return false
  }
  if (v.fn && cbFnObj[v.fn] && cbFnObj[v.fn]) {
    return await cbFnObj[v.fn](param)
  }
}

// 点击详情小图标
export const clickIcon = data => {
  // console.log('clickIcon-->', data)
  if (data.icon === 'phone') {
    if (!data.value) {
      showToast(`号码缺失`)
      return
    }
    window.location.href = `tel:${data.value}`
  }
  if (data.icon === 'copy') {
    let tmp_el = document.createElement('input')
    tmp_el.setAttribute('readonly', 'readonly')
    tmp_el.setAttribute('value', data.value)
    document.body.appendChild(tmp_el)
    tmp_el.select()
    tmp_el.setSelectionRange(0, 50)
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      showToast(`编号复制成功 ${data.value}`)
    }
    document.body.removeChild(tmp_el)
  }
}

// 轮胎订单取消原因
export const cancelReason = ['临时有事去不了', '经销商致电取消服务', '太远了', '需要修改预约时间，重新下单']
